import { render, staticRenderFns } from "./SaleIcon.vue?vue&type=template&id=120ae67e"
import script from "./SaleIcon.vue?vue&type=script&lang=js"
export * from "./SaleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports